import { Badge } from "@dl/web-core-js/ui";
import type { ShopifyTagSourceDTO } from "../../api/shopify";
import { NexpimView } from "../../views";
import { makeConfigPage } from "./makeConfigPage";

/**
 * Which product fields become Shopify tags, on or off, in what order (plan D8).
 * The rows are fixed — one per source the builder knows — so there is no add
 * and no delete; the switch and the row order (drag to change) are the whole
 * configuration.
 */
export const ShopifyTagSourcePage = makeConfigPage<ShopifyTagSourceDTO>({
  path: "/shopify/tag-source",
  cacheKey: "shopify-tag-source",
  titleKey: "navigation.item.shopify-tag-sources",
  titleFallback: "Shopify tags",
  view: NexpimView.API_INVENTORY_UPDATES,
  columns: (c, t) => [
    c.text("source", (row) => row.source, { headerKey: "shopify.tag-source.source", priority: 1 }),
    c.custom(
      "enabled",
      (row) => (row.enabled ? "yes" : "no"),
      (row) =>
        row.enabled ? (
          <Badge size="sm" variant="success">{t("shopify.tag-source.enabled", "Enabled")}</Badge>
        ) : (
          <Badge size="sm" variant="neutral">{t("shopify.tag-source.disabled", "Off")}</Badge>
        ),
      { headerKey: "shopify.tag-source.enabled", priority: 1 },
    ),
  ],
  order: {
    get: (row) => row.sort_order,
    set: (row, order) => ({ ...row, sort_order: order }),
  },
  editor: {
    fields: {
      enabled: {
        kind: "checkbox",
        get: (row) => row.enabled,
        set: (row, value) => ({ ...row, enabled: value }),
      },
    },
    canDelete: false,
  },
});
